import * as React from 'react'
import { INode } from 'shared/types/tree'
import { Box } from '@mui/material'
import { leafOfType } from './utility/TreeHelpers'
import {
  QuestionIssues,
  questionIssueStrings,
} from './tree/masters/questions/QuestionCleanup'
import { LeafTypes } from 'shared/types/ingestion'

export function MapIssues({
  issueKeys,
  node,
}: {
  issueKeys: number[]
  node: INode
}) {
  const [invertedMap] = React.useState<{ [k: number]: string }>(
    Object.keys(QuestionIssues).reduce(
      (obj: { [k: string | number]: string }, key) =>
        (
          // eslint-disable-next-line no-sequences
          (obj[QuestionIssues[key as unknown as number]] = key), obj
        ),
      {},
    ),
  )
  return (
    <Box>
      {issueKeys.map((m, i) => {
        let extra = ''
        switch (m) {
          case QuestionIssues.HasQuestionPointValues: {
            const value = leafOfType(node, LeafTypes.Points)?.body.value
            extra = ` (${value})`
            break
          }
          case QuestionIssues.HasDuplicateLeafTypes: {
            const types = node
              .leaves!.map(({ type }) => type)
              .reduce((acc: string[], type, i, types) => {
                if (types.indexOf(type) !== i) acc.push(type)
                return acc
              }, [])
            extra = ` (${types.join(', ')})`
            break
          }
        }
        return (
          <Box key={i}>{`${m}: ${
            questionIssueStrings[m] || invertedMap[m]
          }${extra}`}</Box>
        )
      })}
    </Box>
  )
}
